import * as Yup from 'yup';

export default Yup.object({
  palletDimension: Yup.string().required('Required')
});
